import { render, staticRenderFns } from "./SynthesisView.vue?vue&type=template&id=424745c4&"
import script from "./SynthesisView.vue?vue&type=script&lang=ts&"
export * from "./SynthesisView.vue?vue&type=script&lang=ts&"
import style0 from "./SynthesisView.vue?vue&type=style&index=0&id=424745c4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports